export default __webpack_public_path__ + "static/media/winner_1.9060614c.jpg";